export default __webpack_public_path__ + "static/media/team.4680c445.png";